export class DOMHelper {
  static setRootCssVariable(document: Document, key: string, value: string): void {
    document.documentElement.style.setProperty(`--${key}`, value);
  }
}
